import { render, staticRenderFns } from "./AddPerformanceTrackingItems.vue?vue&type=template&id=51916132&scoped=true"
import script from "./AddPerformanceTrackingItems.vue?vue&type=script&lang=js"
export * from "./AddPerformanceTrackingItems.vue?vue&type=script&lang=js"
import style0 from "./AddPerformanceTrackingItems.vue?vue&type=style&index=0&id=51916132&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51916132",
  null
  
)

export default component.exports